import { AppEntity, ContactPersonId } from '@app/icare/db/schema/common'
import { CareServiceId } from '@app/icare/entities/careService/schema/CareService'
import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import type { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const NotNeededReasonEnum = defineEnum({
  RELATIVE: msg`Angehöriger`,
  HIMSELF: msg`Selbst`,
  OTHER: msg`Andere`,
})

export type NotNeededReasonType = typeof NotNeededReasonEnum.$.Type

export const PatientCareServiceId = entityId('patientCareService')

export type PatientCareServiceIdType = typeof PatientCareServiceId.Type

export const PatientCareServiceRelationSchema = PatientRelation.extend({
  id: PatientCareServiceId.schema,
  toId: CareServiceId.ref,
})
export type PatientCareServiceRelation = z.infer<typeof PatientCareServiceRelationSchema>

export const PatientCareServiceContactPersonId = entityId('patientCareServiceContactPerson')

export const PatientCareServiceContactPersonSchema = AppEntity.extend({
  id: PatientCareServiceContactPersonId.schema,
  ownerId: PatientCareServiceId.ref,
  contactPersonId: ContactPersonId.ref,
})

export type PatientCareServiceContactPerson = z.infer<typeof PatientCareServiceContactPersonSchema>
